import { Text, VStack } from "@chakra-ui/react";
import { InputRadio } from "components/Atomos/Form/Elements/InputRadio";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { useFormContext } from "react-hook-form";
import { InputSelectDoencas } from "./Selects/InputSelectDoencas";

export const InformacoesSaude = () => {
  const {
    register,
    control,
    watch,
    formState: { errors }
  } = useFormContext();

  const isCastrado = watch("castrado");

  return (
    <VStack flex={1} gap={3} alignItems="flex-start">
      <Text fontSize="lg" fontWeight="medium">
        Informações de Saúde e Condições
      </Text>
      <InputText
        label="Peso Kg"
        name="peso"
        placeholder="00"
        register={register}
        error={errors.peso}
      />
      <InputSelectDoencas control={control} />
      <InputRadio
        label="Animal castrado?"
        name="castrado"
        direction="row"
        control={control}
        error={errors.castrado}
        spacing={2}
        option={[
          {
            value: "true",
            label: "Sim"
          },
          {
            value: "false",
            label: "Não"
          }
        ]}
      />
      <InputRadio
        label="Deseja castrar?"
        name="desejaCastrar"
        direction="row"
        isDisabled={isCastrado === "true"}
        control={control}
        error={errors.desejaCastrar}
        spacing={2}
        option={[
          {
            value: "true",
            label: "Sim"
          },
          {
            value: "false",
            label: "Não"
          }
        ]}
      />
      <InputRadio
        label="Vacinação em dia?"
        name="vacinaEmDia"
        direction="row"
        control={control}
        error={errors.vacinaEmDia}
        spacing={2}
        option={[
          {
            value: "true",
            label: "Sim"
          },
          {
            value: "false",
            label: "Não"
          }
        ]}
      />
      <InputRadio
        label="Deseja vacinar?"
        name="desejaVacinar"
        direction="row"
        control={control}
        error={errors.vacinaEmDia}
        spacing={2}
        option={[
          {
            value: "true",
            label: "Sim"
          },
          {
            value: "false",
            label: "Não"
          }
        ]}
      />
      <InputText
        label="Data da última vacinação"
        name="dataUltimaVacinacao"
        type="date"
        register={register}
        error={errors.dataUltimaVacinacao}
      />
      <InputText
        label="Data de óbito"
        name="dataObito"
        type="date"
        register={register}
        error={errors.dataObito}
      />
    </VStack>
  );
};
